import axios from "@/plugins/axios";

const getNotifications = () => {
  return axios.get('/counters')
}

export default {
  getNotifications
}